import { IEventLoggingComponentProps, withEventLogging } from '@AppModels/Logging';
import { Industry } from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { getIndustryName } from '../../../../models/UiUtils';
import { IndustryTemplateViewModel, IndustryTemplatesViewModel } from '../../../../viewmodels/AdminViewModels';
import { IndustryTemplatesTable } from '../../../components/templates/IndustryTemplatesTable';
import { styleSheet } from './styles';

interface IProps<T extends IndustryTemplateViewModel = IndustryTemplateViewModel> extends IEventLoggingComponentProps {
	className?: string;
	industry: Industry;
	name?: string;
	onMenuItemClicked?(template: T, menuItem: 'edit' | 'archive' | 'delete' | 'publish' | 'copy'): void;
	onTemplateClicked?(template: T, e: React.MouseEvent<HTMLElement>): void;
	styles?: StyleDeclarationValue[];
	templates: IndustryTemplatesViewModel;
}

class _TemplatesByIndustry<T extends IndustryTemplateViewModel = IndustryTemplateViewModel> extends React.Component<
	IProps<T>
> {
	public render() {
		const { className, styles, industry, templates, onMenuItemClicked, onTemplateClicked, name } = this.props;
		return (
			<div className={`${css(...(styles || []))} templates-by-industry ${className || ''}`}>
				<div className={css(styleSheet.header)}>
					<div className={css(styleSheet.headerTitle)}>{getIndustryName(industry)}</div>
					<div className={css(styleSheet.headerAccessory)}>{}</div>
				</div>
				<div className={css(styleSheet.body)}>
					{templates.drafts.length > 0 && (
						<>
							<div>
								<div className={css(styleSheet.sectionTitle, styleSheet.draftsSectionTitle)}>Not Yet Published</div>
								<IndustryTemplatesTable
									industry={industry}
									nameColumnLabel={name ? `${name} Name` : undefined}
									onMenuItemClicked={onMenuItemClicked}
									onTemplateClicked={onTemplateClicked}
									templates={templates}
									type='drafts'
								/>
							</div>
						</>
					)}
					<div>
						<div className={css(styleSheet.sectionTitle)}>{`Live ${name || ''}`}</div>
						<IndustryTemplatesTable
							industry={industry}
							nameColumnLabel={name ? `${name} Name` : undefined}
							onMenuItemClicked={onMenuItemClicked}
							onTemplateClicked={onTemplateClicked}
							templates={templates}
							type='published'
						/>
					</div>
					<div>
						<div className={css(styleSheet.sectionTitle)}>{`Archived ${name || ''}`}</div>
						<IndustryTemplatesTable
							industry={industry}
							nameColumnLabel={name ? `${name} Name` : undefined}
							onMenuItemClicked={onMenuItemClicked}
							onTemplateClicked={onTemplateClicked}
							templates={templates}
							type='archived'
						/>
					</div>
				</div>
			</div>
		);
	}
}

const TemplatesByIndustryAsObserver = observer(_TemplatesByIndustry);
const TemplatesByIndustryWithContext = inject()(TemplatesByIndustryAsObserver);
export const TemplatesByIndustry = withEventLogging(TemplatesByIndustryWithContext, 'TemplatesByIndustry');
